import { replace, truncate } from "lodash/fp";

import { VideoRecording } from "@app/common/types";

export const getVideoRecordingDownloadUrl = (
  videoRecording: VideoRecording,
  { recordingsUrl, filename }: { recordingsUrl: string; filename: string }
) => {
  return `${recordingsUrl}/packaged/${videoRecording.sessionId}/${
    videoRecording.id
  }/stream_0/vod.mp4?recording_access_token=${encodeURIComponent(
    videoRecording.recordingAccessToken
  )}&video_name=${encodeURIComponent(filename)}`;
};

export const getVideoDownloadUrl = (url: string, filename: string) => {
  return `${url}&video_name=${encodeURIComponent(filename)}`;
};

export const getDownloadTitle = (
  title: string | null,
  name: string,
  defaultTitle = "Meeting"
) =>
  replace(
    /\./g,
    "_",
    title
      ? `${truncate({ length: 40, omission: "_" }, title)} ${name}`
      : `${defaultTitle} ${name}`
  );
